// Mid Century Møbler layer: section videos, product-page helpers (ZIP estimate, sizes in/cm, sticky buy bar,
// recently viewed), contact-form prefill and saved pieces. Mirrors the prototype in site/index.src.html.
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d } catch { return d } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)) } catch {} }
  };
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* videos */
  const icons = {
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 4.5h4v15h-4zM13.5 4.5h4v15h-4z"/></svg>',
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15l12-7.5z"/></svg>'
  };
  const setBtn = (btn, playing) => { btn.innerHTML = playing ? icons.pause : icons.play; btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video') };
  function videos() {
    document.querySelectorAll('[data-mcm-video]:not([data-ready])').forEach(btn => {
      const v = document.getElementById(btn.dataset.mcmVideo);
      if (!v) return;
      btn.dataset.ready = '1';
      if (reduce) { v.pause(); v.removeAttribute('autoplay'); setBtn(btn, false) }
      btn.addEventListener('click', () => { if (v.paused) { v.play(); setBtn(btn, true) } else { v.pause(); setBtn(btn, false) } });
    });
  }

  /* ZIP delivery estimate, from the shipping policy */
  function estimate(zip) {
    if (!/^\d{5}$/.test(zip)) return 'Enter a 5-digit ZIP code.';
    const z = +zip.slice(0, 3);
    if ((z >= 995 && z <= 999) || z === 967 || z === 968) return 'Alaska and Hawaii are quoted individually. Contact us and we’ll walk you through the options.';
    if ((z >= 900 && z <= 961) || (z >= 970 && z <= 994)) return 'West Coast: about 2–3 weeks after pickup from the showroom.';
    return 'About 4–6 weeks after pickup from the showroom.';
  }

  /* sizes: "19.25″ wide x 18″ deep x 31″ tall, Seat height: 17.75″" -> chips with an inches/cm toggle */
  function dims() {
    document.querySelectorAll('[data-mcm-dims]:not([data-ready])').forEach(dd => {
      dd.dataset.ready = '1';
      const s = dd.textContent, out = [];
      const re = /([\d.]+)\s*[″"”']*\s*(wide|deep|tall|high|diameter|long)/gi; let m;
      while ((m = re.exec(s))) out.push([{ wide: 'W', deep: 'D', tall: 'H', high: 'H', diameter: 'Ø', long: 'L' }[m[2].toLowerCase()], parseFloat(m[1])]);
      const seat = /seat height:?\s*([\d.]+)/i.exec(s); if (seat) out.push(['Seat', parseFloat(seat[1])]);
      if (!out.length) return;
      let cm = store.get('mcm-cm', false);
      const draw = () => {
        dd.innerHTML = `<span class="mcm-dims">${out.map(([k, v]) => `<span class="mcm-dim"><small>${k}</small>${cm ? Math.round(v * 2.54) + ' cm' : v + '″'}</span>`).join('')}<button type="button" class="mcm-unit">${cm ? 'Show inches' : 'Show cm'}</button></span>`;
        dd.querySelector('.mcm-unit').onclick = () => { cm = !cm; store.set('mcm-cm', cm); draw() };
      };
      draw();
    });
  }

  /* sticky buy bar on phones: shows once the main Add to cart button scrolls away; clicks it */
  function buybar() {
    const bar = document.querySelector('[data-mcm-buybar]');
    const main = document.querySelector('.product-details button[name="add"]');
    if (!bar || !main || bar.dataset.ready) return;
    bar.dataset.ready = '1'; bar.hidden = false;
    new IntersectionObserver(([e]) => bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(main);
    bar.querySelector('[data-mcm-buy]').addEventListener('click', () => main.click());
  }

  /* recently viewed */
  function recent() {
    const me = document.querySelector('[data-mcm-viewed]');
    let list = store.get('mcm-recent', []);
    if (me) {
      try { const p = JSON.parse(me.textContent); list = [p, ...list.filter(x => x.handle !== p.handle)].slice(0, 12); store.set('mcm-recent', list) } catch {}
    }
    const box = document.querySelector('[data-mcm-recent]');
    if (!box) return;
    const items = list.filter(x => x.handle !== box.dataset.current).slice(0, 8);
    if (!items.length) return;
    box.querySelector('[data-mcm-recent-list]').innerHTML = items.map(p => `<a class="mcm-card" href="${esc(p.url)}"><span class="mcm-plinth"><img src="${esc(p.img)}" alt="" loading="lazy"></span><span class="mcm-card__t">${esc(p.title)}</span><span class="mcm-card__p">${esc(p.price)}</span></a>`).join('');
    box.hidden = false;
  }

  /* "Ask a question" -> contact page with the piece filled in */
  function prefill() {
    const q = new URLSearchParams(location.search);
    const piece = q.get('piece');
    const body = document.querySelector('textarea[name="contact[body]"]');
    if (piece && body && !body.value) body.value = `About: ${piece}\n${q.get('url') ? location.origin + q.get('url') : ''}\n\n`;
  }

  /* saved pieces: a heart on every product card and product page, a heart in the header, and a drawer
     listing what's saved (kept in this browser, like the prototype) */
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7.5-4.6-7.5-10.2A4.2 4.2 0 0 1 12 7.3a4.2 4.2 0 0 1 7.5 2.5C19.5 15.4 12 20 12 20Z"/></svg>';
  const getSaved = () => store.get('mcm-saved2', []);
  const handleOf = url => (String(url).match(/\/products\/([^/?#]+)/) || [])[1];
  function cardData(card) {
    const a = card.querySelector('a[href*="/products/"]');
    const img = card.querySelector('img');
    return { handle: handleOf(a.getAttribute('href')), url: a.getAttribute('href').split('?')[0],
      title: (card.querySelector('[role="heading"]') || a).textContent.trim(),
      price: (card.querySelector('.price') || {}).textContent?.trim().split(/\s+/)[0] || '',
      img: img ? (img.currentSrc || img.src) : '' };
  }
  function pageData() {
    const me = document.querySelector('[data-mcm-viewed]');
    try { return JSON.parse(me.textContent) } catch { return null }
  }
  function hearts() {
    document.querySelectorAll('.product-card:not([data-mcm-h])').forEach(card => {
      const a = card.querySelector('a[href*="/products/"]'), g = card.querySelector('.card-gallery');
      if (!a || !g) return;
      card.dataset.mcmH = '1';
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'mcm-heart'; b.dataset.mcmSave = handleOf(a.getAttribute('href'));
      b.setAttribute('aria-label', 'Save'); b.innerHTML = HEART;
      g.style.position = 'relative'; g.appendChild(b);
    });
    const p = pageData(), t = document.querySelector('.mcm-pdp-title');
    if (p && t && !t.parentElement.querySelector('.mcm-heart--pdp')) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'mcm-heart mcm-heart--pdp'; b.dataset.mcmSave = p.handle;
      b.setAttribute('aria-label', 'Save'); b.innerHTML = HEART;
      t.insertAdjacentElement('afterend', b);
    }
    const cart = document.querySelector('.header-actions__cart-icon, cart-icon, [href$="/cart"]');
    if (cart && !document.querySelector('.mcm-saved-btn')) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'mcm-saved-btn'; b.setAttribute('aria-label', 'Saved pieces');
      b.innerHTML = HEART + '<span data-mcm-saved-count data-n="0">0</span>';
      const host = cart.closest('button, a') || cart;
      host.parentElement.insertBefore(b, host);
    }
  }
  function saved() {
    const list = getSaved(), hs = new Set(list.map(x => x.handle));
    document.querySelectorAll('[data-mcm-save]').forEach(b => b.setAttribute('aria-pressed', hs.has(b.dataset.mcmSave)));
    document.querySelectorAll('[data-mcm-saved-count]').forEach(n => { if (n.dataset.n !== String(list.length)) { n.textContent = list.length; n.dataset.n = list.length } });
  }
  function toggleSave(btn) {
    let list = getSaved();
    const h = btn.dataset.mcmSave;
    if (list.some(x => x.handle === h)) list = list.filter(x => x.handle !== h);
    else {
      const card = btn.closest('.product-card');
      const d = card ? cardData(card) : pageData();
      if (d) list = [d, ...list];
    }
    store.set('mcm-saved2', list);
    saved();
  }
  function openSaved() {
    let d = document.getElementById('mcm-saved');
    if (!d) {
      d = document.createElement('div'); d.id = 'mcm-saved'; d.className = 'mcm-drawer'; d.setAttribute('role', 'dialog'); d.setAttribute('aria-label', 'Saved pieces');
      document.body.appendChild(d);
    }
    const list = getSaved();
    d.innerHTML = `<div class="mcm-drawer__scrim" data-mcm-close></div><div class="mcm-drawer__panel"><div class="mcm-drawer__head"><h2 class="mcm-h2">Saved</h2><button type="button" class="mcm-x" data-mcm-close aria-label="Close">×</button></div>
      <div class="mcm-drawer__body">${list.length ? list.map(p => `<div class="mcm-li"><a class="mcm-plinth" href="${esc(p.url)}"><img src="${esc(p.img)}" alt=""></a><div><a href="${esc(p.url)}">${esc(p.title)}</a><div class="mcm-muted">${esc(p.price)}</div><button type="button" class="mcm-li__rm" data-mcm-save="${esc(p.handle)}">Remove</button></div></div>`).join('')
        : '<p class="mcm-muted">Tap the heart on any piece to keep it here. Vintage pieces are one of a kind, so don’t wait too long.</p>'}</div></div>`;
    requestAnimationFrame(() => d.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  }
  function closeSaved() { const d = document.getElementById('mcm-saved'); if (d) d.classList.remove('is-open'); document.body.style.overflow = '' }

  function clamp() { document.querySelectorAll('[data-mcm-clamp]').forEach(d => { d.onclick = () => d.classList.toggle('is-open') }) }

  /* remember the last category visited, so "Keep browsing" after a contact message goes back there */
  function lastCat() {
    const m = location.pathname.match(/^(\/collections\/[^/]+)(\/|$)/);
    if (m && m[1] !== '/collections/vendors' && m[1] !== '/collections/types') { try { sessionStorage.setItem('mcm-last-cat', m[1] + (m[2] === '/' ? '' : location.search)) } catch {} }
  }

  function init() { lastCat(); clamp(); videos(); dims(); buybar(); recent(); prefill(); hearts(); saved() }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-mcm-est]');
    if (!f) return;
    e.preventDefault();
    f.parentElement.querySelector('.mcm-est-out').textContent = estimate(f.querySelector('input').value.trim());
  });
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-mcm-save]');
    if (b) { e.preventDefault(); e.stopPropagation(); toggleSave(b); if (b.classList.contains('mcm-li__rm')) openSaved(); return }
    if (e.target.closest('.mcm-saved-btn')) { e.preventDefault(); openSaved(); return }
    if (e.target.closest('[data-mcm-close]')) closeSaved();
  }, true);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeSaved() });
  let mo = 0;
  new MutationObserver(() => { if (mo) return; mo = requestAnimationFrame(() => { mo = 0; hearts(); saved() }) }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
